// Strategy-document helpers shared by the Content strategy panel and the
// document view. Each mirrors a backend function in
// app/contentiq/services/docx_render.py so the screen and the .docx agree.

// A two-touch product (Content Syndication – 2 Touch): its recipe declares
// touches, and its assets come in PAIRS — one per engagement phase.
export function isTwoTouchFormat(format) {
  return !!(format && format.strategy_recipe && format.strategy_recipe.touches);
}

// A two-touch build's assets as pairs (Edward, 2026-10-28: "two pairs, not a
// list of 4 assets"). One page_plan entry per pair; asset_ids are
// [Engagement Phase 1 asset, Engagement Phase 2 asset]. Mirrors asset_pairs().
export function assetPairs(pagePlan, items) {
  const byId = {};
  (items || []).forEach(s => { if (s && s.asset_id) byId[s.asset_id] = s; });
  const pairs = [];
  ((pagePlan && pagePlan.pages) || []).forEach(pg => {
    const ids = ((pg && pg.asset_ids) || []).filter(a => Number.isInteger(a)).slice(0, 2);
    if (!ids.length) return;
    pairs.push({
      name: String(pg.name || `Pair ${pairs.length + 1}`),
      members: ids.map((id, i) => ({ phase: i + 1, assetId: id, item: byId[id] || null })),
    });
  });
  return pairs;
}

const BULLET_MARK = /^\s*(?:[•·▪◦‣∙*]|-(?=\s)|\d+[.)](?=\s))\s*/;

// A copy block's lines as list items, or null when it is prose: a BULLETS
// block, or one whose every line starts with a bullet mark (the 2026-10-28
// walkthrough: bullets printed as plain lines). Mirrors bullet_lines().
export function bulletLines(label, text) {
  const lines = String(text || '').split('\n').filter(l => l.trim());
  if (!lines.length) return null;
  const marked = lines.every(l => BULLET_MARK.test(l));
  if (!marked && !/bullet/i.test(label || '')) return null;
  return lines.map(l => l.replace(BULLET_MARK, '').trim());
}
